import {Button, Col, Row} from "react-bootstrap";
import PropTypes, {shape} from "prop-types";
import {useBusyContext} from "../../contexts/busycontext";

export function ModalContentContainer(props) {
    const {onOpenChanged, onEditingChanged, children, style,onClosed} = props;
    const {busy}=useBusyContext();

    return <Row className={"g-0"} style={style ? style : {}}>
        <Col className={"text-end"} xs={12}>
            <Button disabled={busy} style={{position: "relative", top: "-0px"}} className={"btn-close"}
                    onClick={() => {
                        onOpenChanged(false);
                        onEditingChanged && onEditingChanged(undefined);
                    }}></Button>
        </Col>
        <Col xs={12}>
            {children}
        </Col>


    </Row>
}

ModalContentContainer.propTypes = {
    onOpenChanged: PropTypes.func,
    onEditingChanged: PropTypes.func,
    children: PropTypes.any,
    style: PropTypes.shape()
}